// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollPatientRequestModel } from './enrollPatientRequestModel.js';
import type { SignatureDocumentUpload } from './signatureDocumentUpload.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentWithSignatureUpload {
    'enrollmentRequest': EnrollPatientRequestModel | null;
    'signatureDocumentUpload': SignatureDocumentUpload | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentWithSignatureUpload>> = [
        {
            "name":     "enrollmentRequest",
            "baseName": "enrollmentRequest",
            "type":     "EnrollPatientRequestModel"
        },
        {
            "name":     "signatureDocumentUpload",
            "baseName": "signatureDocumentUpload",
            "type":     "SignatureDocumentUpload"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentWithSignatureUpload.attributeTypeMap;
    }
}
